import api, { unwrap } from './client';
import type { ApiResponse, PageResponse } from '@/types/api';
import type { MasterAdminCreateRequest, PlatformUserResponse } from '@/types/platformUser';
import type { SearchParams } from '@/types/api';

export const masterUsersApi = {
  list: (params?: SearchParams & { masterOnly?: boolean; organizationId?: number; activeOnly?: boolean }) =>
    unwrap(api.get<ApiResponse<PageResponse<PlatformUserResponse>>>('/v1/master/users', { params })),

  createMasterAdmin: (body: MasterAdminCreateRequest) =>
    unwrap(api.post<ApiResponse<PlatformUserResponse>>('/v1/master/admins', body)),
};
